import React, { Component } from 'react'

// @material-ui/core components
import Radio from "@material-ui/core/Radio";
import Typography from "@material-ui/core/Typography";
import FormControlLabel from "@material-ui/core/FormControlLabel";

// @material-ui/icons
import FiberManualRecord from "@material-ui/icons/FiberManualRecord";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

//
import {
  // primaryColor,
  dangerColor,
  // successColor,
  // defaultFont,
  // whiteColor,
  // grayColor
} from "assets/jss/material-dashboard-pro-react.jsx";

import _ from "lodash";

import style from "./DXFormStyles";

import Icon from "@material-ui/core/Icon";
import Popover from '@material-ui/core/Popover';

export default class DXFormInputSelection extends Component {

  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
    }
  }

  onClickInfo = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  }

  handleClose = () => {
    this.setState({ anchorEl: null });
  }

  render() {
    const {
      pid,
      question,
      valueState,
      setFormValueState,
      classes
    } = this.props;

    const id = `${pid}.${question.id}`;

    const { titleStyle = { sm: 2 }, tip = null } = question;
    const { sm } = titleStyle;
    const { anchorEl } = this.state;

    const error = _.get(valueState, `${id}State`) === 'error';

    return <GridContainer key={id} justify='center'>
      <GridItem xs={12} sm={sm}>
        <h4 className={classes.infoText}>
          {
            question.required && error
              ? <span className={classes.required}>필수</span>
              : ''
          }
          {question.title}
          {
            tip
              ? <span className={classes.infoIconForQuestion}>
                <Icon fontSize="small" color={"disabled"} onClick={this.onClickInfo}>info</Icon>
                <Popover
                  id={id}
                  open={Boolean(anchorEl)}
                  anchorEl={anchorEl}
                  onClose={this.handleClose}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                  }}
                >
                  <div className={classes.tipArea}>{tip.split('\n').map(txt => <div>{txt}</div>)}</div>
                </Popover>
              </span>

              : null
          }

        </h4>
      </GridItem>
      <GridItem
        xs={12}
        sm={12 - sm}
        style={{ ...style.padding15px }}
      >
        {
          question.options.map(({ title, value }, index) => <FormControlLabel
            key={`${index}${value}`}
            control={
              <Radio
                key={value}
                disabled={setFormValueState === null || question.prefill}
                checked={_.get(valueState, id) === value}
                onChange={e => {
                  setFormValueState(id, value);
                  setFormValueState(`${id}State`, 'success')
                }}
                value={value}
                name="radio button"
                aria-label={title}
                icon={
                  <FiberManualRecord
                    style={style.radioUnchecked}
                  />
                }
                checkedIcon={
                  <FiberManualRecord
                    style={style.radioChecked}
                  />
                }
              />
            }
            label={<Typography className={classes.inputSelectionExampleText}>{title}</Typography>}
          />
          )
        }
      </GridItem>
    </GridContainer >
  }
}
